import { curry } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import sequenceComponentState from 'lib/sequence/component/state'
import back from 'app/_shared/events/redirect/back'
import { hide, show } from 'lib/sequence/component/state/hidden'

const {
  get: getActiveTab,
  set: setActiveTab,
} = sequenceComponentState('activeTab')

/**
 * If the current `activeTab` of the `tabs` element is not the first one, sets the previous tab
 * as the element's `activeTab`.
 *
 * If the current `activeTab` is the first one, redirects back.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const previousTabOrBack = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { tabs } = find(actionComponent)
  const [btnNext, btnUnderstood] = actionComponent[G.ACTIONS]
  const activeTab = getActiveTab(tabs)
  const children: [] = tabs[G.CHILDREN]
  const childrenIds = children.map((child: any) => child[G.PROPS].id)
  const index = childrenIds.indexOf(activeTab)

  hide(btnUnderstood)
  show(btnNext)

  if (index - 1 >= 0) {
    setActiveTab(tabs, childrenIds[index - 1])
    await module[G.ADAPTER][G.UI].update(module)
  } else {
    await back(module, component, event)
  }
}

export default curry(previousTabOrBack)
